var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_564",
    "data-name": "Group 564",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M0,0H16V16H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M11.164,10.333H6.836L5.769,13H4.333l4-10H9.667l4,10H12.231ZM10.631,9,9,4.923,7.369,9ZM3,14.333H15v1.333H3Z",
    transform: "translate(-1 -1)",
    fill: "#484747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColour);
export default __webpack_public_path__ + "static/media/colour.6f151d779596b557df51aeb9757137ae.svg";
export { ForwardRef as ReactComponent };